import { getProperty } from '../../functions/get-property';
import { HydraView } from './hydra-view';

export class HydraCollection<T> {
  context: string;
  id: string;
  type: string;

  members: T[];

  totalItems: number;
  view: HydraView|null;

  constructor(response: {[index: string]: any}) {
    this.context = getProperty(response, '@context');
    this.id = getProperty(response, '@id');
    this.type = getProperty(response, '@type');

    this.totalItems = getProperty(response, 'hydra:totalItems');
    this.members = getProperty(response, 'hydra:member');

    const hydraView = getProperty(response, 'hydra:view');
    this.view = hydraView ? new HydraView(hydraView) : null;
  }
}
